import { useDispatch } from 'react-redux'
import { partition } from 'lodash-es'
import { default as AlertsUtil } from 'utils/Alerts'
import { useAlerts } from 'state/Alerts'
import ClickableAlert from './ClickableAlert'
import OrderAlert from './OrderAlert'
import { closeAlert } from './actions'
import './styles.scss'

export default function Alerts() {
	const all = useAlerts()
	const [orderAlerts, normalAlerts] = partition(all, { type: AlertsUtil.TYPES.ORDER })

	const dispatch = useDispatch()
	const doClose  = list => () => closeAlert(dispatch, list)

	const needsBackdrop = (normalAlerts.length > 0 || orderAlerts.length > 0)

	return <div id="bottom-alerts">
		{needsBackdrop && <div id="alert-backdrop" onClick={doClose(all)}/>}
		{normalAlerts.slice(0, ClickableAlert.MAX_ALERTS).map(alert => <ClickableAlert key={alert.id} {...alert}/>)}
		{<OrderAlert list={orderAlerts} doClose={doClose}/>} {/* TODO: doesn't really respect MAX_ALERTS... :( */}
	</div>
}
